

type MenuIcon = {
    active?: boolean;
    action?: (param?: any) => void
}


export function StarIcon({ active = false, action }: MenuIcon) {
    return (
        <svg
            onClick={() => action && action()
            }

            width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.96875 0.0300293C9.28125 0.0300293 9.53125 0.217529 9.65625 0.467529L11.8125 4.87378L16.5938 5.59253C16.875 5.62378 17.0938 5.84253 17.1875 6.09253C17.2812 6.37378 17.2188 6.65503 17 6.87378L13.5312 10.3113L14.3438 15.155C14.4062 15.4363 14.2812 15.7488 14.0625 15.905C13.8125 16.0613 13.5 16.0925 13.25 15.9675L8.96875 13.655L4.6875 15.9675C4.4375 16.0925 4.15625 16.0613 3.90625 15.905C3.6875 15.7488 3.5625 15.4363 3.59375 15.155L4.4375 10.3113L0.96875 6.87378C0.75 6.65503 0.6875 6.37378 0.78125 6.09253C0.875 5.84253 1.09375 5.62378 1.375 5.59253L6.15625 4.87378L8.3125 0.467529C8.4375 0.217529 8.6875 0.0300293 8.96875 0.0300293ZM8.96875 2.49878L7.34375 5.90503C7.21875 6.12378 7.03125 6.28003 6.78125 6.31128L3.0625 6.84253L5.75 9.49878C5.9375 9.68628 6 9.93628 5.96875 10.1863L5.34375 13.905L8.625 12.155C8.84375 12.03 9.125 12.03 9.34375 12.155L12.625 13.905L12 10.1863C11.9375 9.93628 12.0312 9.68628 12.2188 9.49878L14.875 6.84253L11.1875 6.31128C10.9375 6.28003 10.7188 6.12378 10.625 5.90503L8.96875 2.49878Z" fill="#6E7586" />
        </svg>)


}